'use client'
import React from 'react'
import styles from './styles.module.scss'
import { LoadingSpinner } from '../../Loaders'

interface GradientOutlinedButtonProps {
  onClick?: () => void
  text?: string
  children: React.ReactNode
  loading?: boolean
  disabled?: boolean
}
const GradientOutlinedButton: React.FC<GradientOutlinedButtonProps> = ({
  children,
  onClick,
  text,
  loading = false,
  disabled = false,
}) => {
  return (
    <button
      className={styles.button}
      style={{ textTransform: text === 'upper' ? 'uppercase' : 'initial' }}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading ? <LoadingSpinner size="sm" /> : <span>{children}</span>}
    </button>
  )
}
export default GradientOutlinedButton
